export default "__VITE_ASSET__BIIyIOqI__"